__turbopack_context__.v({
  "hidden": "utility-module-scss-module__7Rrz5a__hidden",
  "scrollbar": "utility-module-scss-module__7Rrz5a__scrollbar",
  "scrollbarHidden": "utility-module-scss-module__7Rrz5a__scrollbarHidden",
  "scrollbarTransparent": "utility-module-scss-module__7Rrz5a__scrollbarTransparent",
});
